import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';

import * as userDetails from '../../../redux/appointmentForm/requests/user-details-req';
import {
  selectProgressCareUser,
  selectProgressPatientForm,
  selectUserDetails,
  selectUserDetailsPending,
} from '../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  careUser: selectProgressCareUser(state),
  patientForm: selectProgressPatientForm(state),
  userDetailsLoading: selectUserDetailsPending(state),
  details: selectUserDetails(state),
});

const mapDispatchToProps = {
  userDetailsReq: userDetails.actions.send,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentDidMount() {
      const { patientForm, careUser, userDetailsReq, details } = this.props;
      const { id } = careUser;

      if (!patientForm && get(details, 'id') !== id) {
        userDetailsReq({ id });
      }
    },
  }),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/hocs/withUserDetails.js